import PropTypes from "prop-types";

export const choiceProptype = PropTypes.shape({
  choice_id: PropTypes.number,
  text: PropTypes.string,
  voter_ids: PropTypes.arrayOf(PropTypes.string),
  votes: PropTypes.number,
});

export const pollQuestionProptype = PropTypes.shape({
  question: PropTypes.string,
  choices: PropTypes.arrayOf(choiceProptype),
});

export const activePollProptype = PropTypes.shape({
  can_see_results: PropTypes.bool,
  data: pollQuestionProptype,
  id: PropTypes.string,
});

export const pollsProptype = PropTypes.arrayOf(
  PropTypes.shape({
    can_see_results: PropTypes.bool,
    content_type: PropTypes.string,
    created_by_id: PropTypes.string,
    data: pollQuestionProptype,
    date_created: PropTypes.string,
    date_modified: PropTypes.string,
    id: PropTypes.string,
    is_template: PropTypes.bool,
    template_display_order: PropTypes.number,
  }),
);
